import React, { useEffect, useState } from 'react'
import {
    Row,
    Col,
    Card,
    CardBody,
    Media,
} from "reactstrap";
import { Link } from "react-router-dom";
import { postSubmitForm } from '../../helpers/forms_helper';
import WelcomeComp from '../../pages/Dashboard/WelcomeComp';

const DashboardForCSM = () => {

    useEffect(() => {
        loadItemOrderCounts();
    }, [])

    const [itemOrderCounts, setAllItemOrderCounts] = useState();
    const loadItemOrderCounts = async () => {
        let url = process.env.REACT_APP_BASEURL + "itemorders/order_counts";
        let response = await postSubmitForm(url, "");
        if (response.status === 1) {
            setAllItemOrderCounts(response.data);
        }
    };
    return (
        <>
            <Row>
            <Col md="5">
                  <WelcomeComp />
                </Col>
                <Col md="7">
                <Row>
{/* Reports Render */}

                {/* <Col md="4">
                        <Link to="/items/new_orders">
                          <Card className="mini-stats-wid bg-danger">
                            <CardBody>
                              <Media>
                                <Media body>
                                  <p
                                    className="fw-medium"
                                    style={{ color: "white" }}
                                  >
                                    Orders
                                  </p>
                                  <h4
                                    className="mb-0"
                                    style={{ color: "white" }}
                                  >
                                    {itemOrderCounts &&
                                      itemOrderCounts.new_orders}
                                  </h4>
                                </Media>
                              </Media>
                            </CardBody>
                          </Card>
                        </Link>
                      </Col> */}
                <Col md="4">
                    <Link to="/items/urgent_orders">
                        <Card className="mini-stats-wid" style={{backgroundColor: "#ffebee",color:"#b71c1c",border:"1px solid #f7766f"}}>
                            <CardBody style={{paddingLeft:"0px",paddingRight:"0px",textAlign:"center",height:"100px"}}>
                                <Media>
                                    <Media body>
                                        <p className="fw-medium">
                                            Urgent
                                        </p>
                                        <h4
                                            className="mb-0"
                                            style={{ color: "#b71c1c" }}
                                        >
                                            {itemOrderCounts &&
                                                itemOrderCounts.urgent_orders || 0}
                                        </h4>
                                    </Media>
                                </Media>
                            </CardBody>
                        </Card>
                    </Link>
                </Col>

                <Col md="4">
                    <Link to="/items/orders_in_process">
                        <Card className="mini-stats-wid" style={{backgroundColor: "#fff8e1",color:"#f57f17",border:"1px solid #f7dc79"}}>
                            <CardBody  style={{paddingLeft:"0px",paddingRight:"0px",textAlign:"center",height:"100px"}}>
                                <Media>
                                    <Media body>
                                        <p className="fw-medium">
                                            In Process
                                        </p>
                                        <h4
                                            className="mb-0"
                                            style={{ color: "#f57f17" }}
                                        >
                                            {itemOrderCounts &&
                                                itemOrderCounts.in_process_orders || 0}
                                        </h4>
                                    </Media>
                                </Media>
                            </CardBody>
                        </Card>
                    </Link>
                </Col>
                <Col md="4">
                    <Link to="/items/closed_orders">
                        <Card className="mini-stats-wid"  style={{backgroundColor: "#e8f5e9",color:"#1b5e20", border:"1px solid #9dde81"}}>
                            <CardBody style={{paddingLeft:"0px",paddingRight:"0px",textAlign:"center",height:"100px"}}>
                                <Media>
                                    <Media body>
                                        <p className="fw-medium">
                                            Closed
                                        </p>
                                        <h4
                                            className="mb-0"
                                            style={{ color: "#1b5e20" }}
                                        >
                                            {itemOrderCounts &&
                                                itemOrderCounts.closed_orders || 0}
                                        </h4>
                                    </Media>
                                </Media>
                            </CardBody>
                        </Card>
                    </Link>
                </Col>
                </Row>
                </Col>
                
            </Row>
        </>
    )
}

export default DashboardForCSM